import { render } from "./Commerce.vue?vue&type=template&id=b86ce232"
import script from "./Commerce.vue?vue&type=script&lang=js"
export * from "./Commerce.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__